export const isUrlWithSupportedEndpoint = (url: string) => {
  const regEx = /\/.*\/(wait|stream)$/g;
  return regEx.test(url);
};
